var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReturnHeader',{attrs:{"header":"สินค้ารอคืนยังไม่ได้ทำใบ CN","img_header":_vm.header_image,"link_back":"stock/storage/returnstorage"}}),_c('Return_product')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }